<div #global class="global-table-container">
  <p-table
    #pTable
    id="tabla"
    [value]="_internalList"
    [columns]="getColumns()"
    [resizableColumns]="true"
    [scrollable]="true"
    [reorderableColumns]="true"
    styleClass="p-datatable-striped p-datatable-gridlines p-datatable-sm"
    [rowHover]="true"
    class="table"
    [scrollHeight]="scrollHeight"
    columnResizeMode="expand"
    currentPageReportTemplate=" {first}-{last} de {totalRecords} resultados"
    [lazy]="true"
    (onLazyLoad)="onTableDataChange($event)"
  >
    <!-- Section for Table support buttons -->
    <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <!-- eslint-disable @angular-eslint/template/elements-content -->
        <button
          *ngIf="hasExportPdf"
          pButton
          class="button button-red-outline mr-2 button-icon"
          icon="pi pi-file-pdf"
          (click)="onExportPDF()"
        ></button>
        <!-- eslint-disable @angular-eslint/template/elements-content -->
        <button
          *ngIf="hasExportExcel"
          pButton
          class="button button-green-outline mr-2 button-icon"
          icon="pi pi-file-excel"
          [loading]="loadingExcel"
          [disabled]="loadingExcel"
          (click)="onExportExcel()"
        ></button>
        <div *ngIf="hasExportExcel || hasExportPdf" class="vertical-line"></div>
        <!-- eslint-disable @angular-eslint/template/elements-content -->
        <button
          *ngIf="hasClearButton"
          id="clearFiltersButton"
          pButton
          label="Borrar"
          class="p-button-outlined btn-radius btn-clear-filters"
          icon="pi pi-filter-slash"
          (click)="onClearFilters()"
        ></button>
        <sbi-cot-back-button-table-config
          *ngIf="this.hasConfigurationTableButton"
          [listColumns]="listConfigColumns"
          [isLoading]="_getConfigListadoRequested$ | async"
          (changeConfig)="onChangeConfig($event)"
          (saveConfig)="onSaveConfig()"
        ></sbi-cot-back-button-table-config>
        <label
          *ngIf="this.data?.hasCustomCheckbox"
          class="custom-checkbox-container custom-checkbox"
        >
          {{ this.data?.customCheckboxName }}
          <input
            [disabled]="_getConfigListadoRequested$ | async"
            [checked]="customCheckboxValue"
            (click)="toggleFilter(!customCheckboxValue)"
            type="checkbox"
          />
          <span class="checkmark">
            <i class="fas fa-check"></i>
          </span>
        </label>
      </div>
    </ng-template>

    <!-- TABLE HEADER -->
    <ng-template pTemplate="header" let-columns="columns">
      <tr>
        <ng-container *ngFor="let col of getColumns()">
          <ng-template #headerTemplate>
            <ng-container>
              <span>{{ col.header }}</span>
              <span *ngIf="col.sort">
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </span>
              <span *ngIf="!!col.filterType">
                <p-columnFilter
                  *ngIf="
                    col.filterType === 'text' || col.filterType === 'numeric'
                  "
                  type="{{ col.filterType }}"
                  field="{{ col.field }}"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                  [matchModeOptions]="col.matchModeOptions"
                  [matchMode]="col?.matchModeOptions?.[0].value || 'contains'"
                ></p-columnFilter>

                <p-columnFilter
                  *ngIf="
                    col.filterType !== 'text' &&
                    col.filterType !== 'multipleDropdown' &&
                    col.filterType !== 'dropdown' &&
                    col.filterType !== 'date' &&
                    col.filterType !== 'multiselect' &&
                    col.filterType !== 'numeric'
                  "
                  type="{{ col.filterType }}"
                  field="{{ col.field }}"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                  [matchModeOptions]="col.matchModeOptions"
                ></p-columnFilter>

                <p-columnFilter
                  *ngIf="col.filterType === 'dropdown'"
                  [matchModeOptions]="col.matchModeOptions"
                  field="{{ col.field }}"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                  matchMode="equals"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-select
                      [ngModel]="value"
                      [options]="col.filteOptions"
                      optionLabel="name"
                      optionValue="value"
                      (onChange)="customFilterCallback(filter, $event.value)"
                      [placeholder]="col.header"
                      [showClear]="true"
                    ></p-select>
                  </ng-template>
                </p-columnFilter>

                <p-columnFilter
                  *ngIf="col.filterType === 'multiselect'"
                  field="{{ col.field }}"
                  display="menu"
                  matchMode="in"
                  [showOperator]="false"
                  [showAddButton]="false"
                  [showMatchModes]="false"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-multiSelect
                      [ngModel]="value"
                      [options]="col.filteOptions"
                      optionLabel="name"
                      optionValue="value"
                      (ngModelChange)="customFilterCallback(filter, $event)"
                      [placeholder]="col.header"
                      [showClear]="true"
                    >
                      <ng-template let-option pTemplate="item">
                        <div class="p-multiselect-representative-option">
                          <span class="p-ml-1">{{ option.name }}</span>
                        </div>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>

                <p-columnFilter
                  *ngIf="col.filterType === 'multipleDropdown'"
                  [matchModeOptions]="col.matchModeOptions"
                  field="{{ col.field }}"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                  matchMode="equals"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-multiSelect
                      class="multiple-select-filter"
                      [ngModel]="value"
                      [options]="col.filteOptions"
                      [placeholder]="col.header"
                      (onChange)="customFilterCallback(filter, $event.value)"
                      optionLabel="name"
                      optionValue="value"
                    >
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
                <p-columnFilter
                  *ngIf="col.filterType === 'date'"
                  [matchModeOptions]="col.matchModeOptions"
                  display="menu"
                  field="{{ col.field }}"
                  [showOperator]="false"
                  [showAddButton]="false"
                  type="{{ col.filterType }}"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                    *ngIf="!col.filterBy"
                  >
                    <p-datepicker
                      #calendar
                      view="month"
                      [ngModel]="value"
                      (onSelect)="customFilterCallback(filter, calendar.value)"
                      (onInput)="onInputDate(calendar.value, col.field)"
                      dateFormat="mm/yy"
                    ></p-datepicker>
                  </ng-template>

                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                    *ngIf="col.filterBy === 'day'"
                  >
                    <p-datepicker
                      #calendar2
                      [ngModel]="value"
                      (onSelect)="customFilterCallback(filter, calendar2.value)"
                      (onInput)="onInputDate(calendar2.value, col.field)"
                      dateFormat="dd/mm/yy"
                    ></p-datepicker>
                  </ng-template>
                </p-columnFilter>
              </span>
            </ng-container>
          </ng-template>
          <th
            *ngIf="!col.frozen"
            [pSortableColumn]="col.sort ? col.field : ''"
            pReorderableColumn
            pResizableColumn
            [ngClass]="col.class"
          >
            <div class="sort-header">
              <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
            </div>
          </th>
          <th
            *ngIf="col.frozen && this.showActionHeader"
            [pSortableColumn]="''"
            pFrozenColumn
            [frozen]="col.frozen"
            [alignFrozen]="col.alignFrozen"
            [ngClass]="col.class"
          >
            <div class="frozen-header">
              <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
            </div>
          </th>
        </ng-container>
      </tr>
    </ng-template>

    <!-- TABLE BODY SROLLABLE -->
    <ng-template pTemplate="body" let-acc let-columns="columns">
      <tr
        class="p-selectable-row"
        [ngClass]="{ 'row-updated': acc.__highlight }"
      >
        <ng-container *ngFor="let col of columns">
          <ng-template #bodyTemplate>
            <ng-container *ngIf="!col.template">
              {{ acc[col.field] }}
            </ng-container>
            <ng-container *ngIf="col.template">
              <ng-container
                *ngTemplateOutlet="
                  col.template;
                  context: { $implicit: { col: col, acc: acc } }
                "
              ></ng-container>
            </ng-container>
          </ng-template>

          <td
            *ngIf="!col.frozen && !this.loading"
            [ngClass]="col.class + ' ui-resizable-column'"
            [pTooltip]="
              col.showTooltip && !col.template ? acc[col.field] : null
            "
            tooltipPosition="top"
            [escape]="false"
          >
            <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
          </td>
          <td
            *ngIf="col.frozen && !this.loading"
            pFrozenColumn
            [frozen]="col.frozen"
            [alignFrozen]="col.alignFrozen"
            [ngClass]="col.class"
            [pTooltip]="
              col.showTooltip && !col.template ? acc[col.field] : null
            "
            tooltipPosition="top"
            [escape]="false"
          >
            <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
          </td>
        </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr *ngIf="!loading">
        <td
          [attr.colspan]="getColumns().length"
          class="empty-message-cell"
        ></td>
      </tr>
    </ng-template>
  </p-table>

  <div
    class="empty-state-overlay"
    *ngIf="!loading && _internalList?.length === 0"
  >
    No se encontraron resultados.
  </div>
  <div
    class="d-flex flex-row justify-content-between align-items-baseline cont paginator-container"
  >
    <div class="mt-2">
      <span *ngIf="hasResultsCount" class="results">{{ countTitle() }}</span>
    </div>
    <p-paginator
      *ngIf="hasPaginator"
      #paginator
      class="paginator"
      [rows]="rows"
      [totalRecords]="totalTableItems"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [dropdownAppendTo]="'body'"
      (onPageChange)="paginate($event)"
    ></p-paginator>
  </div>
  <app-prime-loader
    *ngIf="
      loading ||
      loadingExcel ||
      (_getConfigListadoRequested$ | async) ||
      (_setConfigListadoRequested$ | async)
    "
  ></app-prime-loader>
</div>
